import { Cinema } from "../cinema-module/cinema";
import { PdpCinema } from "./pdp-cinema";

const cinema = new Cinema();
cinema.setSendTracking(false);
cinema.init(1);

const pdpCinema = new PdpCinema(cinema);
pdpCinema.init();
